export default function ProductModalSkeleton() {
	return (
		<div
			className="container flex max-lg:flex-col lg:items-start lg:gap-x-12 xl:gap-x-20 
					max-md:pt-0 lg:!px-8 xl:!px-20 
					h-[calc(100vh_-_23px)] w-screen overflow-hidden 
					z-10 animate-pulse"
		>
			{/* Image Gallery Container */}
			<div
				className="sm:w-1/2 xl:w-2/3 lg:min-h-screen max-lg:w-screen 
						overflow-hidden max-md:flex-shrink-0 max-md:-translate-x-4 max-lg:-translate-x-6 pb-10 mt-14
						lg:h-max flex lg:flex-col gap-3 lg:gap-10"
			>
				{/* Images */}
				<div className="relative max-lg:aspect-[330/270] lg:aspect-[1032/710] bg-skeleton-gray max-lg:h-[270px] rounded-lg"></div>
				<div className="relative max-lg:aspect-[330/270] lg:aspect-[1032/710] bg-skeleton-gray max-lg:h-[270px] rounded-lg"></div>
				<div className="relative max-lg:aspect-[330/270] lg:aspect-[1032/710] bg-skeleton-gray max-lg:h-[270px] rounded-lg"></div>
			</div>

			{/* Product Info Container */}
			<div className="flex flex-col w-full lg:w-[456px] lg:pt-20 lg:h-[calc(100vh_-_22px)]">
				{/* Breadcrumbs */}
				<div className="h-4 bg-skeleton-gray w-2/3 rounded mb-8"></div>

				{/* Product Name */}
				<div className="h-10 bg-skeleton-gray w-5/6 rounded mb-4"></div>

				{/* Rating */}
				<div className="h-3 bg-skeleton-gray w-[100px] rounded mb-10"></div>

				{/* Color Name */}
				<div className="h-3 bg-skeleton-gray w-[70px] rounded mb-3"></div>

				{/* Colors */}
				<div className="flex flex-wrap gap-1.5 mb-6">
					<div className="w-5 h-5 bg-skeleton-gray rounded-full"></div>
					<div className="w-5 h-5 bg-skeleton-gray rounded-full"></div>
					<div className="w-5 h-5 bg-skeleton-gray rounded-full"></div>
					<div className="w-5 h-5 bg-skeleton-gray rounded-full"></div>
					<div className="w-5 h-5 bg-skeleton-gray rounded-full"></div>
					<div className="w-5 h-5 bg-skeleton-gray rounded-full"></div>
					<div className="w-5 h-5 bg-skeleton-gray rounded-full"></div>
					<div className="w-5 h-5 bg-skeleton-gray rounded-full"></div>
					<div className="w-5 h-5 bg-skeleton-gray rounded-full"></div>
					<div className="w-5 h-5 bg-skeleton-gray rounded-full"></div>
					<div className="w-5 h-5 bg-skeleton-gray rounded-full"></div>
					<div className="w-5 h-5 bg-skeleton-gray rounded-full"></div>
					<div className="w-5 h-5 bg-skeleton-gray rounded-full"></div>
					<div className="w-5 h-5 bg-skeleton-gray rounded-full"></div>
					<div className="w-5 h-5 bg-skeleton-gray rounded-full"></div>
					<div className="w-5 h-5 bg-skeleton-gray rounded-full"></div>
					<div className="w-5 h-5 bg-skeleton-gray rounded-full"></div>
					<div className="w-5 h-5 bg-skeleton-gray rounded-full"></div>
					<div className="w-5 h-5 bg-skeleton-gray rounded-full"></div>
					<div className="w-5 h-5 bg-skeleton-gray rounded-full"></div>
				</div>

				{/* order details */}
				<div className="my-3">
					<div className="h-3 bg-skeleton-gray w-full rounded mb-2.5"></div>
					<div className="h-3 bg-skeleton-gray w-full rounded mb-2.5"></div>
					<div className="h-3 bg-skeleton-gray w-full rounded mb-2.5"></div>
					<div className="h-3 bg-skeleton-gray w-[270px] rounded"></div>
				</div>

				{/* Have Questions? */}
				<div className="bg-skeleton-gray rounded-xl h-32 px-8 mt-8 mb-10"></div>

				{/* CTA Container */}
				<div className="cta-container border-0">
					{/* Button */}
					<div className="button button-lg bg-skeleton-gray w-full max-md:mt-5 mt-10 !pt-2.5"></div>

					{/* Pricing | Instant Quote */}
					<div className="flex justify-center gap-4 mt-2 mb-12">
						<div className="h-3 bg-skeleton-gray w-2/6 rounded"></div>
						<div className="h-3 bg-skeleton-gray w-1/6 rounded"></div>
					</div>
				</div>
			</div>
		</div>
	)
}
